export default __webpack_public_path__ + "6ca61723d030cc0656bb641ddf6c80c7.svg";